<!-- Trigger link -->
<a class="trouble-link" (click)="open()">Having trouble? Clear cache &amp; cookies</a>

<!-- Modal -->
<div class="cache-modal-backdrop" *ngIf="isOpen" (click)="onBackdropClick($event)">
  <div class="cache-modal">

    <div class="cache-modal-head">
      <div class="cache-modal-head-icon">🧹</div>
      <div class="cache-modal-head-text">
        <h3>Clear Cache &amp; Cookies</h3>
        <p>Fixes most login &amp; display issues</p>
      </div>
      <button class="cache-modal-close" (click)="close()">✕</button>
    </div>

    <div class="cache-modal-body">
      <p>Your browser stores old SingSnap data that can cause login problems or pages not loading correctly. Clearing it is safe — your account and recordings are never affected.</p>

      <div class="cache-clear-list" *ngIf="!showProgress">
        <div class="cache-clear-list-label">The following will be cleared:</div>
        <div class="cache-clear-item"><span class="cache-item-icon delete">🗑️</span> SingSnap app data &amp; local storage</div>
        <div class="cache-clear-item"><span class="cache-item-icon delete">🗑️</span> SingSnap session cookies</div>
        <div class="cache-clear-item"><span class="cache-item-icon delete">🗑️</span> SingSnap cached scripts &amp; files</div>
        <div class="cache-clear-item no"><span class="cache-item-icon safe">🔒</span> Your account &amp; recordings — never affected</div>
      </div>

      <div class="cache-progress-steps" *ngIf="showProgress">
        <div class="cache-step" [class.complete]="steps.storage">
          <div class="cache-step-dot">✓</div> Clearing SingSnap storage &amp; session data
        </div>
        <div class="cache-step" [class.complete]="steps.cookies">
          <div class="cache-step-dot">✓</div> Removing SingSnap cookies
        </div>
        <div class="cache-step" [class.complete]="steps.caches">
          <div class="cache-step-dot">✓</div> Clearing SingSnap cached files
        </div>
        <div class="cache-step" [class.complete]="steps.reload">
          <div class="cache-step-dot">✓</div> Reloading page
        </div>
      </div>

      <div class="cache-modal-footer">
        <button
          class="cache-btn-clear"
          [class.running]="isRunning"
          [class.done]="isDone"
          [disabled]="isRunning || isDone"
          (click)="runClear()"
        >
          {{ isDone ? '✓ Done! Reloading...' : isRunning ? 'Clearing...' : '🧹 Clear Now' }}
        </button>
        <button class="cache-btn-cancel" *ngIf="!isRunning && !isDone" (click)="close()">
          Cancel
        </button>
      </div>
    </div>

  </div>
</div>
